import { Directive, HostBinding } from '@angular/core';

@Directive({
  selector: '[bui-tbody-tr]'
})

export class DataTbodyTrDirective {
  @HostBinding(`class.ant-table-row`) true;
}
